module.exports = __webpack_public_path__ + "static/media/logomedicall24.5b546f67.png";